import PageHeaderRoot from './PageHeaderRoot';
import PageSummary from './PageSummary';

const PageHeaderStandard = () => {
  return (
    <PageHeaderRoot
      variant="standard"
      // maxWidth="lg"
      paper
      afterCol={<PageSummary variant="h4" GridColProps={{ offsetMd: 2, md: 8 }} />}
      GridProps={{ cx: { rowGap: 'xl', pT: '5xl' } }}
      GridColProps={{ offsetMd: 2, md: 8 }}
    />
  );
};

export default PageHeaderStandard;
